import React, {
    FC, useEffect, useState,
} from 'react';

import { Button } from 'antd';
import { LeftOutlined, RightOutlined } from '@ant-design/icons';
import classNames from 'classnames';
import { observer } from 'mobx-react';

import i18n from '@/content';
import TabTitle from '../../../Common/TabTitle';
import Spinner from '../../../Common/Spin';
import ConfigureGroup from './ConfigureGroup';
import UserGroupsSidebar from './UserGroupsSidebar';
import { useStores } from '../../../hooks';
import styles from './UserGroups.module.scss';

const nameSpace = 'customGroupsEditor';

const UserGroups: FC = observer(() => {
    const { usersListStore } = useStores();
    const [isMobileSidebarOpen, setIsMobileSidebarOpen] = useState(true);

    const {
        loadingCustomGroups,
        fetchUsersCustomGroups,
        newGroupsMode,
    } = usersListStore;
    const title = newGroupsMode ? 'titleCreate' : 'titleConfigure';

    useEffect(() => {
        fetchUsersCustomGroups();
    }, []);

    const closeSidebar = (): void => setIsMobileSidebarOpen(false);

    return (
        <Spinner spinning={loadingCustomGroups} screenCentered>
            <TabTitle title="Groups" />
            <div data-testid="userGroups_container" className={classNames(styles['groups-editor'], {
                [styles['sidebar-open']]: isMobileSidebarOpen,
            })}>
                <UserGroupsSidebar title="Groups" onClose={closeSidebar} />
                <div className={styles['groups-settings-container']}>
                    <Button
                        data-testid="userGroups_toggleSidebarButton"
                        type="text"
                        className={styles['mobile-sidebar-tab']}
                        onClick={() => setIsMobileSidebarOpen((prev) => !prev)}
                        icon={isMobileSidebarOpen ? <LeftOutlined /> : <RightOutlined />}
                    />
                    <div className={styles['group-title']}>
                        {i18n.t(`${nameSpace}.${title}`)}
                    </div>
                    <ConfigureGroup />
                </div>
            </div>
        </Spinner>
    );
});

export default UserGroups;
